import React from "react";
import styled from "styled-components";
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Select,
  Spin,
  Divider,
  FloatButton,
  Tooltip,
  Card,
  Typography,
  Tabs,
  InputNumber,
  Upload,
  Collapse,
  ColorPicker,
  DatePicker,
  Tag,
  message
} from "antd";
import {
  CloseCircleFilled,
  CheckOutlined,
  CloseOutlined,
  BellOutlined,
  TeamOutlined,
  PlusCircleOutlined,
  PlusCircleFilled,
  CheckCircleOutlined,
  StopFilled,
  CloseCircleOutlined,
  RocketFilled,
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
  CaretRightOutlined,
  RightCircleFilled,
  CommentOutlined,
  CustomerServiceOutlined,
  SwapRightOutlined,
  InfoCircleFilled,
  EditFilled,
  DownloadOutlined
} from '@ant-design/icons';
import { Form } from "@ant-design/compatible";
import { resolveSelectedSite } from 'src/utils/selectedSite';
import { withIsMobile } from 'src/utils/responsive';
import Notify from "src/components/meta/Notification";
import Highlighter from "react-highlight-words";
import Resizer from 'react-image-file-resizer';
import slugify from 'slugify';
import dayjs from 'dayjs';
import XLSX from 'sheetjs-style';
import { saveAs } from 'file-saver';
const { Title } = Typography;
const { Column } = Table;
const FormItem = Form.Item;

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

const ResponsiveFormWrap = styled.span`
  @media (max-width: 991px) {
    display: block;
    width: 100%;
    min-width: 0;

    .ant-col {
      flex: 0 0 100% !important;
      max-width: 100% !important;
      margin-top: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .ant-row {
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding-left: 1em !important;
      padding-right: 1em !important;
    }
    .action-plan-primary-fields {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0.65em;
    }
    .action-plan-primary-fields .ant-col {
      min-width: 0;
    }
    .ant-form-item {
      margin-bottom: 1em;
    }
    .ant-input,
    .ant-input-number,
    .ant-picker,
    .ant-select,
    .ant-upload,
    .ant-upload-select {
      width: 100% !important;
      max-width: 100% !important;
    }
    .ant-input,
    .ant-input-number,
    .ant-picker,
    .ant-select-selector {
      min-height: 44px !important;
      border-radius: 8px !important;
    }
    .ant-input,
    .ant-picker-input > input,
    .ant-input-number-input,
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      font-size: 16px !important;
    }
    .ant-input-number-input {
      height: 42px;
    }
    textarea.ant-input {
      min-height: 110px !important;
    }
    .ant-form-item-label {
      padding-bottom: 0.3em;
    }
    .ant-form-item-label > label {
      height: auto;
      white-space: normal;
      line-height: 1.3;
    }
    .avatar-uploader,
    .avatar-uploader .ant-upload {
      width: 100% !important;
      max-width: 100%;
    }
    .avatar-uploader .ant-upload {
      min-height: 12em;
      border-radius: 10px;
    }
    .avatar-uploader img {
      height: auto !important;
      max-height: 14em;
    }
  }
`;
const StyledTable = styled(Table)`
  @media (max-width: 991px) {
    .ant-table-content,
    .ant-table-body {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch;
      touch-action: pan-x pan-y;
      scrollbar-width: thin;
      scrollbar-color: #80ce90 #eef2ef;
    }
    .ant-table-content::-webkit-scrollbar,
    .ant-table-body::-webkit-scrollbar {
      height: 8px;
    }
    .ant-table-content::-webkit-scrollbar-track,
    .ant-table-body::-webkit-scrollbar-track {
      background: #eef2ef;
      border-radius: 999px;
    }
    .ant-table-content::-webkit-scrollbar-thumb,
    .ant-table-body::-webkit-scrollbar-thumb {
      background: #80ce90;
      border-radius: 999px;
    }
    .ant-table table {
      min-width: 40em;
    }
    .ant-table-thead > tr > th {
      white-space: nowrap;
      padding: 10px 12px;
      background: #fafafa !important;
      color: #262626 !important;
      font-size: 12px;
      font-weight: 700;
    }
    .ant-table-cell-fix-right {
      background: #fff;
      z-index: 4;
      box-shadow: -5px 0 10px rgba(0, 0, 0, 0.06);
    }
    .ant-table-thead .ant-table-cell-fix-right {
      background: #fafafa !important;
      z-index: 6;
    }
    .ant-table-container {
      overflow: hidden;
      border: 1px solid #e3ebe5;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 4px 14px rgba(31, 61, 38, 0.06);
    }
    .ant-table-tbody > tr > td {
      padding: 10px 12px;
      font-size: 13px;
      line-height: 1.35;
    }
    .ant-table-tbody > tr:nth-child(even):not(.ant-table-expanded-row) > td {
      background: #fbfcfb;
    }
    .ant-table-expanded-row > td {
      padding: 8px !important;
      background: #eff6f1 !important;
    }
    .ant-table-expanded-row .ant-table-wrapper {
      margin: 0 !important;
    }
    .ant-table-tbody .ant-table-cell-fix-right .anticon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 36px;
      min-height: 36px;
    }
    .ant-table-row-expand-icon {
      width: 30px !important;
      height: 30px !important;
      min-width: 30px;
      min-height: 30px;
      border: 1px solid rgba(128, 206, 144, 0.65) !important;
      border-radius: 50% !important;
      background: #f3fff6 !important;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
      cursor: pointer;
    }
    .ant-table-row-expand-icon::before {
      top: 13px !important;
      right: 7px !important;
      left: 7px !important;
      height: 2px !important;
      background: #80ce90 !important;
    }
    .ant-table-row-expand-icon::after {
      top: 7px !important;
      bottom: 7px !important;
      left: 13px !important;
      width: 2px !important;
      background: #80ce90 !important;
    }
    .ant-table-row-expand-icon-cell {
      position: sticky !important;
      left: 0;
      width: 48px;
      min-width: 48px;
      max-width: 48px;
      padding: 8px !important;
      z-index: 5;
      background: #fff !important;
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell {
      background: #fafafa !important;
      z-index: 7;
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell + th,
    .ant-table-tbody > tr > .ant-table-row-expand-icon-cell + td {
      position: sticky !important;
      left: 48px;
      z-index: 4;
      background: #fff !important;
      box-shadow: 5px 0 10px rgba(0, 0, 0, 0.05);
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell + th {
      background: #fafafa !important;
      color: #262626 !important;
      z-index: 6;
    }
    .ant-pagination {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      row-gap: 0.5em;
    }
  }
`;
const Cards = styled(Card)`

  :where(.css-dev-only-do-not-override-133wgew).ant-card .ant-card-body{
    padding-left:0px !important;
    padding-bottom: 3em !important;
  }

  @media (max-width: 991px) {
    width: 100%;
    min-width: 0;
    margin-bottom: 1em;

    > .ant-card-head {
      min-height: auto;
      padding: 0.9em 1em;
      border-bottom: 1px solid #edf1ee;
    }
    .ant-card-head-wrapper {
      flex-wrap: wrap;
      gap: 0.5em;
    }
    .ant-card-extra {
      width: 100%;
      margin-left: 0;
    }
    > .ant-card-body {
      padding: 1em !important;
      padding-bottom: 6em !important;
    }
  }
`;
const MobileEditActions = styled.div`
  display: none;

  @media (max-width: 991px) {
    position: fixed;
    right: 1em;
    bottom: 0.5em;
    bottom: calc(0.5em + env(safe-area-inset-bottom));
    left: 1em;
    z-index: 50;
    display: flex;
    gap: 0.65em;
    padding: 0.65em;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 0.8em;
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
    backdrop-filter: blur(8px);

    .ant-btn {
      flex: 1 1 0;
      height: 44px;
      border-radius: 0.65em;
      font-weight: 700;
    }
  }
`;
const ActionPlanToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8em;
  flex-direction: row-reverse;

  @media (max-width: 991px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.55em;

    .action-site {
      grid-column: 1 / -1;
    }
    .action-add,
    .action-export {
      width: 100%;
      min-width: 0;
      height: 44px;
      margin-top: 0 !important;
    }
    .ant-picker,
    .ant-select {
      width: 100% !important;
      min-width: 0;
    }
  }
`;
const ActionPlanStatusBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5em;

  .ant-tag {
    margin: 0;
  }
  .ant-select {
    margin-left: auto;
  }

  @media (max-width: 991px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    .ant-tag {
      width: 100%;
      padding: 0.55em !important;
      overflow: hidden;
      font-size: 12px !important;
      text-align: center;
      text-overflow: ellipsis;
    }
    .ant-select {
      grid-column: 1 / -1;
      width: 100% !important;
      margin: 0.4em 0 0 !important;
    }
  }
`;
const MobileTableHelp = styled.div`
  display: none;

  @media (max-width: 991px) {
    display: flex;
    align-items: center;
    gap: 0.55em;
    margin-top: 1em;
    padding: 0.65em 0.8em;
    border: 1px solid rgba(128, 206, 144, 0.45);
    border-radius: 10px;
    background: #f3faf5;
    color: #42624a;
    font-size: 12px;

    strong {
      flex: 0 0 auto;
      padding: 0.25em 0.45em;
      border-radius: 5px;
      background: #dff2e3;
      color: #2f7e43;
      font-size: 10px;
      letter-spacing: 0.04em;
    }
  }
`;
const StyledTabs = styled(Tabs)`
.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
  padding: 11px 19px !important;
  background-color: red !important;
}
`;
const StyledInputNumber = styled(InputNumber)`
  font-weight: 500 !important;
  color: #525f7f !important;
  font-size: 15px !important;
  cursor: not-allowed;
  .ant-input-number-disabled .ant-input-number-input {
    font-weight: 500 !important;
    color: #525f7f !important;
    font-size: 15px !important;
    cursor: not-allowed;
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;

function callback(key) {
  console.log(key);
}
const children = [];
for (let i = 10; i < 36; i++) {
  children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
}

function handleChange(value) {
  console.log(`selected ${value}`);
}
class SpecialFormClass extends React.Component {
  state = {
    descriptions: this.props.descriptions,
    mainSpecialImage1: undefined,
  };
  componentDidMount = () => {
    if (this.props.editSpecial) {
      this.setState({
        mainSpecialImage1: this.props.editSpecial.mainSpecialImage1,
      });
    }
  }

  handleMainSpecialImage1 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainSpecialImage1: imageUrl
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1000, 1000, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };
  selectItem = value => {
    if (value.substr(0, 4) === "Add ") {
      let parsedValue = value.substr(4, value.length);
      this.props.form.setFieldsValue({ description: parsedValue });
      let descriptions = this.state.descriptions;
      descriptions.pop();
      descriptions.push({ value: parsedValue });
      this.setState({ descriptions: descriptions });
    }
  };
  searchItem = (value, b) => {
    let descriptions = this.state.descriptions;
    if (descriptions[descriptions.length - 1].value.substr(0, 4) === "Add ") {
      descriptions.pop();
    }
    if (
      !descriptions.find(
        descriptions => descriptions.value.toLowerCase() === value.toLowerCase()
      ) &&
      value !== ""
    ) {
      descriptions.push({ value: "Add " + value });
    }
    this.setState({ descriptions: descriptions });
  };
  render() {
    // Only offer people who actually belong to the site this action is for.
    // Follow the form's own "Assign To" value so the list tracks a site change
    // made here, falling back to the record's site, then the page selection.
    const formAccess = this.props.form.getFieldValue('access');
    const editAccess = this.props.editSpecial
      ? Array.isArray(this.props.editSpecial.access)
        ? this.props.editSpecial.access[0]
        : this.props.editSpecial.access
      : undefined;
    const selectedSiteId = String(
      formAccess || editAccess || this.props.siteSelected || ''
    );

    // Compare as strings: user.access holds ids that may be ObjectIds or
    // strings depending on how the record was written.
    let availableUsers = selectedSiteId
      ? (this.props.users || []).filter(user =>
          (user.access || []).map(String).includes(selectedSiteId)
        )
      : this.props.users || [];

    // Keep whoever is already assigned selectable, even if they no longer have
    // access to this site — otherwise editing an old action silently drops them.
    const currentResponsible = this.props.editSpecial
      ? this.props.editSpecial.actionResponsible
      : undefined;
    if (
      currentResponsible &&
      !availableUsers.some(user => user.name === currentResponsible)
    ) {
      availableUsers = [
        ...availableUsers,
        { _id: `current-${currentResponsible}`, name: currentResponsible }
      ];
    }

    return (
      <ResponsiveFormWrap>
      <Form layout="vertical">
        <Row
          className="action-plan-primary-fields"
          gutter={24}
          style={{ padding: "3em", paddingTop: "1em", paddingBottom: "0em" }}
        >
          <Col span={4}>
            <FormItem label={<span>Date</span>}>
              {this.props.form.getFieldDecorator("actionDate", {
                rules: [{ required: true, message: "Action Plan Name is required" }],
                initialValue: this.props.editSpecial
                  ? dayjs(this.props.editSpecial.actionDate)
                  : undefined
              })(
                <DatePicker
                  // disabled
                  maxLength={30}
                  size="large"
                // placeholder={"Please Enter Action Plan Name"}
                />
              )}
            </FormItem>
          </Col>
          <Col span={5}>
            <FormItem
              // style={{ marginBottom: '1em' }}
              label="Deadline"
            >
              {this.props.form.getFieldDecorator(
                'actionDeadline',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Category required'
                    }
                  ],
                  initialValue: this.props.editSpecial
                    ? dayjs(this.props.editSpecial.actionDeadline)
                    : undefined
                }
              )(
                <DatePicker
                  style={{ width: "100%" }}
                  variant={
                    this.props.form.getFieldValue(
                      'actionDeadline'
                    ) == null
                      ? 'outlined'
                      : 'filled'
                  }
                  size="large"
                  placeholder="Select Deadline"
                />
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{}}>

            <FormItem
              label="Priority"
            >
              {this.props.form.getFieldDecorator('actionPriority', {
                rules: [
                  { required: false, message: 'Supplier Name required' }
                ],
                initialValue: this.props.editSpecial
                  ? this.props.editSpecial.actionPriority
                  : undefined
              })(
                <Select
                  size="large"
                  showSearch
                  allowClear
                >
                  <Option key="1" value="1" >
                    1
                  </Option>
                  <Option key="2" value="2" >
                    2
                  </Option>
                  <Option key="3" value="3" >
                    3
                  </Option>
                  <Option key="4" value="4" >
                    4
                  </Option>
                  <Option key="5" value="5" >
                    5
                  </Option>

                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{}}>   <FormItem label={<span>Assign To</span>}>
            {this.props.form.getFieldDecorator('access', {
              initialValue: this.props.editSpecial
                ? this.props.editSpecial.access
                : this.props.siteSelected
            })(
              <Select
                size="large"
                // mode="multiple"
                showSearch
                onChange={() => {
                  // The Responsible list is scoped to this site, so whoever was
                  // picked for the previous one is no longer a valid choice.
                  this.props.form.setFieldsValue({
                    actionResponsible: undefined
                  });
                }}>
                {/* <Option key="Admin" value="Admin">
                  Admin
                </Option> */}
                {this.props.sites.map(site => (
                  <Option key={site._id} value={site._id}>
                    {site.name}
                    {/* {site.name} ({site._id}) */}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
          </Col>
        </Row>
        <Row gutter={24} style={{ padding: "3em", paddingTop: "1em", paddingBottom: "0em" }}>
          <Col span={4} style={{ marginTop: "1em" }}>

            <FormItem
              label="Department"
            >
              {this.props.form.getFieldDecorator('actionDepartment', {
                rules: [
                  { required: false, message: 'Supplier Name required' }
                ],
                initialValue: this.props.editSpecial
                  ? this.props.editSpecial.actionDepartment
                  : undefined
              })(
                <Select
                  size="large"
                  showSearch
                  allowClear
                >
                  <Option key="HR" value="HR" >
                    HR
                  </Option>
                  <Option key="Collateral" value="Collateral" >
                    Collateral
                  </Option>
                  <Option key="Guest experience" value="Guest experience" >
                    Guest experience
                  </Option>
                  <Option key="Guest feedback" value="Guest feedback" >
                    Guest feedback
                  </Option>
                  <Option key="Laundry" value="Laundry" >
                    Laundry
                  </Option>
                  <Option key="Service stock" value="Service stock" >
                    Service stock
                  </Option>
                  <Option key="Maintenance" value="Maintenance" >
                    Maintenance
                  </Option>
                  <Option key="Operations" value="Operations" >
                    Operations
                  </Option>
                  <Option key="Health & Safety" value="Health & Safety" >
                    Health & Safety
                  </Option>
                  <Option key="Finance" value="Finance" >
                    Finance
                  </Option>
                  <Option key="BOH" value="BOH" >
                    BOH
                  </Option>
                  <Option key="Service Training" value="Service Training" >
                    Service Training
                  </Option>
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={6} style={{ marginTop: "1em" }}>

            <FormItem
              label="Responsible "
            >
              {this.props.form.getFieldDecorator('actionResponsible', {
                rules: [
                  { required: false, message: 'Supplier Name required' }
                ],
                initialValue: this.props.editSpecial
                  ? this.props.editSpecial.actionResponsible
                  : undefined
              })(
                <Select
                  size="large"
                  showSearch
                  allowClear
                >
                  {availableUsers.map(user => (
                    <Option key={user._id} value={user.name}>
                      {user.name}
                      {/* {site.name} ({site._id}) */}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{ marginTop: "1em" }}>

            <FormItem
              label="Status"
            >
              {this.props.form.getFieldDecorator('actionStatus', {
                rules: [
                  { required: false, message: 'Supplier Name required' }
                ],
                initialValue: this.props.editSpecial
                  ? this.props.editSpecial.actionStatus
                  : undefined
              })(
                <Select
                  size="large"
                  showSearch
                  allowClear
                >
                  <Option key="Completed" value="Completed" >
                    Completed
                  </Option>
                  <Option key="In Progress" value="In Progress" >
                    In Progress
                  </Option>
                  <Option key="Pending" value="Pending" >
                    Pending
                  </Option>
                  <Option key="On Hold" value="On Hold" >
                    On Hold
                  </Option>
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={24} style={{ padding: "3em", paddingTop: "1em", paddingBottom: "0em" }}>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem
              label="Action Required"
            >
              {this.props.form.getFieldDecorator(
                'actionAction',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Category required'
                    }
                  ],
                  initialValue: this.props.editSpecial
                    ? this.props.editSpecial.actionAction
                    : ""
                }
              )(
                <TextArea
                  style={{ width: "100%" }}
                  variant={
                    this.props.form.getFieldValue(
                      'actionAction'
                    ) == null
                      ? 'outlined'
                      : 'filled'
                  }
                  size="large"
                  placeholder="Enter action plan"
                />
              )}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem
              // style={{ marginBottom: '1em' }}
              label="Notes"
            >
              {this.props.form.getFieldDecorator(
                'actionNote',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Category required'
                    }
                  ],
                  initialValue: this.props.editSpecial
                    ? this.props.editSpecial.actionNote
                    : ""
                }
              )(
                <TextArea
                  style={{ width: "100%" }}
                  variant={
                    this.props.form.getFieldValue(
                      'actionNote'
                    ) == null
                      ? 'outlined'
                      : 'filled'
                  }
                  size="large"
                  placeholder="Enter Note"
                />
              )}
            </FormItem>
          </Col>

        </Row>
        <Row>
          <Col span={10} style={{ padding: "3em", paddingTop: "1em" }}>
            <h1 style={{
              marginBottom: '1em',
              fontSize: '15px',
              fontWeight: 400,

              // fontFamily: "Nunito",
            }}>Upload Image</h1>
            <Upload
              name="mainSpecialImage1"
              className="avatar-uploader"
              listType="picture-card"
              showUploadList={false}
              beforeUpload={this.beforeUpload}
              customRequest={this.handleImageUpload}
              onChange={this.handleMainSpecialImage1}
              loading={this.state.loading}
              accept="image/*"
            >
              {
                this.state.mainSpecialImage1 ? (
                  <img
                    style={{
                      width: '100%',
                      height: "20em",
                      objectFit: "contain"
                    }}
                    alt="example"
                    src={
                      this.state.mainSpecialImage1.search('data') > -1
                        ? this.state.mainSpecialImage1
                        : process.env.REACT_APP_GLOBAL_SERVER +
                        'sproutmanagement/api/images/' +
                        this.state.mainSpecialImage1
                    }
                  />
                ) : (
                  <div
                    style={{
                      marginTop: 8,
                    }}
                  >
                    Upload
                  </div>
                )
              }
            </Upload>
          </Col>
        </Row>
      </Form>
      </ResponsiveFormWrap>
    );
  }
}
const SpecialForm = Form.create()(SpecialFormClass);
class SliderFormClass extends React.Component {
  state = {
    descriptions: this.props.descriptions,
    mainSpecialImage1: undefined,
  };
  componentDidMount = () => {
    if (this.props.editSpecial) {
      this.setState({
        mainSpecialImage1: this.props.editSpecial.mainSpecialImage1,
      });
    }
  }

  handleMainSpecialImage1 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainSpecialImage1: imageUrl
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1000, 1000, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };
  selectItem = value => {
    if (value.substr(0, 4) === "Add ") {
      let parsedValue = value.substr(4, value.length);
      this.props.form.setFieldsValue({ description: parsedValue });
      let descriptions = this.state.descriptions;
      descriptions.pop();
      descriptions.push({ value: parsedValue });
      this.setState({ descriptions: descriptions });
    }
  };
  searchItem = (value, b) => {
    let descriptions = this.state.descriptions;
    if (descriptions[descriptions.length - 1].value.substr(0, 4) === "Add ") {
      descriptions.pop();
    }
    if (
      !descriptions.find(
        descriptions => descriptions.value.toLowerCase() === value.toLowerCase()
      ) &&
      value !== ""
    ) {
      descriptions.push({ value: "Add " + value });
    }
    this.setState({ descriptions: descriptions });
  };
  render() {
    return (
      <ResponsiveFormWrap>
      <Form layout="vertical">
        <Row gutter={24} style={{ padding: "2em", paddingTop: 0, paddingBottom: "0em" }}>
          <Col span={8}>
            <FormItem label={<span>Slider Name</span>}>
              {this.props.form.getFieldDecorator("specialNameSlider", {
                rules: [{ required: true, message: "Site name is required" }],
                initialValue: this.props.editSpecial
                  ? this.props.editSpecial.specialNameSlider
                  : "",
              })(<Input size="large" placeholder={"Please enter site name"} />)}
            </FormItem>
          </Col>{" "}

          <Col span={8}>
            <FormItem label={<span>Slider Decription</span>}>
              {this.props.form.getFieldDecorator("specialDescriptionSlider", {
                rules: [{ required: true, message: "Site name is required" }],
                initialValue: this.props.editSpecial
                  ? this.props.editSpecial.specialDescriptionSlider
                  : "",
              })(<Input size="large" placeholder={"Please enter site name"} />)}
            </FormItem>
          </Col>{" "}
          <Col span={24} style={{ marginTop: "1em" }}>

            <FormItem
              label="Add products that will be showcased on this product slider"
            >
              {this.props.form.getFieldDecorator('sliderProducts', {
                rules: [
                  { required: true, message: 'Supplier Name required' }
                ],
                initialValue: this.props.editSpecial
                  ? this.props.editSpecial.sliderProducts
                  : undefined
              })(
                <Select allowClear
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } mode="multiple" size="large" showSearch>
                  {this.props.stock.map(stock => (
                    <Option key={stock._id} value={stock._id}>
                      {stock.productTitle}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: "1em" }}>
            <FormItem
              label="Assign categories for slider to be displayed on"
            >
              {this.props.form.getFieldDecorator('sliderCollection', {
                rules: [
                  { required: true, message: 'Supplier Name required' }
                ],
                initialValue: this.props.editSpecial
                  ? this.props.editSpecial.sliderCollection
                  : undefined
              })(
                <Select mode="multiple" size="large" showSearch>
                  <Option key={"Homepage"} value={"Homepage"}>
                    Homepage
                  </Option>
                  {this.props.sites.map(item => (
                    <Option key={item._id} value={item._id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>
      </Form>
      </ResponsiveFormWrap>
    );
  }
}
const SliderForm = Form.create()(SliderFormClass);

class Special extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: dayjs().format('YYYY'),
      loading: false,
      closed: false,
      rejectReason: "",
      editSpecial: undefined,
      activeKey: "Action Plan", // Default active key
      siteSelected: resolveSelectedSite(
        this.props.selectedSite,
        this.props.sites
      ),
      size: "large",
      flag: false,
      currentTab: "All",
      selectedMonths: [dayjs().format("MM")],
    };
  }

  componentWillMount = async () => {
    this.setState({ loading: true });

    Promise.all([
      // this.fetchAllStock(),
      this.fetchAllSpecial(),
      this.fetchAllSites(),
      this.fetchAllUsers()
    ])
      .then(() => {
        // On a cold start the constructor ran before sites existed, so
        // siteSelected was null and the first fetch was unscoped. Pick the
        // first site now and redo the fetch so the form saves against a real
        // site instead of a null access.
        const siteSelected =
          this.state.siteSelected ||
          (this.props.sites[0] ? this.props.sites[0]._id : null);
        const needsRefetch = !this.state.siteSelected && siteSelected;

        this.setState({ loading: false, siteSelected }, () => {
          if (needsRefetch) this.fetchAllSpecial();
        });


        window.addEventListener("resize", this.resizeEvent);

        if (window.cordova) {
          document.addEventListener("backbutton", this.handleBack);
        }
      })
      .catch(error => {
        console.error("Error during componentDidMount:", error);
        this.setState({ loading: false });
        Notify("error", "Error", error.message || "An error occurred");
      });
  };



  // fetchAllStock = () => {
  //   return this.props.findAllStock().catch(error => {
  //     throw new Error(`Error fetching stock: ${error}`);
  //   });
  // };

  fetchAllSpecial = () => {
    const { selectedYear, selectedMonths, siteSelected } = this.state;

    return this.props
      .findAllSpecial(siteSelected, selectedYear, selectedMonths)
      .catch(error => {
        throw new Error(`Error fetching special stock: ${error}`);
      });
  };
  fetchAllSites = () => {
    return this.props.findAllSites().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };

  fetchAllUsers = () => {
    return this.props.findAllUsers().catch(error => {
      throw new Error(`Error fetching users: ${error}`);
    });
  };

  handleBack = () => {
    if (this.state.previewVisible) {
      this.setState({ previewVisible: false, previewVisibleVariant: false });
    } else {
      this.props.history.goBack();
    }
  };
  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  specialForm;
  onAddSpecial = e => {
    this.setState({ addSpecialVisible: true, editSpecial: undefined });
  };

  onAddSlider = e => {
    this.setState({ addSliderVisible: true, editSpecial: undefined });
  };


  handleAddSpecial = e => {
    e.preventDefault();
    this.specialForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        values.mainSpecialImage1 = this.specialForm.state.mainSpecialImage1;
        // Store plain calendar dates. Serialising the dayjs object sends UTC,
        // which pushes a local date of the 1st back into the previous month.
        if (values.actionDate) {
          values.actionDate = dayjs(values.actionDate).format("YYYY-MM-DD");
        }
        if (values.actionDeadline) {
          values.actionDeadline = dayjs(values.actionDeadline).format("YYYY-MM-DD");
        }
        if (this.state.editSpecial) {
          values._id = this.state.editSpecial._id;
        }
        this.props
          .addSpecial(values)
          .then(() => {
            this.props
              .findAllSpecial(this.state.siteSelected, this.state.selectedYear, this.state.selectedMonths)
              .then(() => {
                if (this.state.editSpecial) {
                  Notify("success", "Successfully saved");
                } else {
                  Notify("success", "Successfully added");
                }
                this.specialForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  addSpecialVisible: false,
                  addSliderVisible: false,
                  editSpecial: undefined,
                  currentTab: "All",
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify("error", e);
              });
          })

          .catch(e => {
            this.setState({ loading: false });
            Notify("error", e);
          });
      }
    });
  };
  handleAddSlider = e => {
    e.preventDefault();
    this.sliderForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        if (this.state.editSpecial) {
          values._id = this.state.editSpecial._id;
        }
        this.props
          .addSpecial(values)
          .then(() => {
            this.props
              .findAllSpecial(this.state.siteSelected, this.state.selectedYear, this.state.selectedMonths)
              .then(() => {
                if (this.state.editSpecial) {
                  Notify("success", "Successfully saved");
                } else {
                  Notify("success", "Successfully added");
                }
                this.sliderForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  addSpecialVisible: false,
                  addSliderVisible: false,
                  editSpecial: undefined,
                  currentTab: "All",
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify("error", e);
              });
          })

          .catch(e => {
            this.setState({ loading: false });
            Notify("error", e);
          });
      }
    });
  };

  handleEditSpecial = e => {
    this.setState({ addSpecialVisible: true, editSpecial: e });
  };
  handleEditSlider = e => {
    this.setState({ addSliderVisible: true, editSpecial: e });
  };


  handleDeleteSpecial = e => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute("data");
    const { siteSelected, selectedYear, selectedMonths } = this.state;

    Modal.confirm({
      centered: true,
      title: "Confirm delete",
      content: (
        <div>
          <h4>Are you sure you want to delete this Item?</h4>
        </div>
      ),
      onCancel() {
        // no-op
      },
      onOk: async () => {
        this.setState({ loading: true });
        try {
          // 1. Delete
          await this.props.deleteSpecial(id);

          // 2. Re-fetch with the same filters
          await this.props.findAllSpecial(
            siteSelected,
            selectedYear,
            selectedMonths
          );

          Notify("success", "Successfully deleted");

          // 3. Reset loading/tab and reapply any client-side filtering
          this.setState(
            {
              loading: false,
              currentTab: "All"
            },
            this.filterData
          );
        } catch (err) {
          this.setState({ loading: false });
          Notify("error", err);
        }
      }
    });
  };

  handleDeleteSlider = e => {
    const id = e.currentTarget.getAttribute("data");
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are you sure you want to delete?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteSpecial(id)
          .then(() => {
            that.props
              .findAllSpecial(this.state.siteSelected, this.state.selectedYear, this.state.selectedMonths)
              .then(() => {
                that.setState({ loading: false, currentTab: "All" });
                // that.props.find140mm();
                // that.props.find171mm();
                Notify("success", "Successfully deleted");
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify("error", e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify("error", e);
          });
      },
      oncancel() { },
    });
  };

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', pagination, sorter);
    this.setState({
      sortedInfo: sorter
    });
  };
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search Action`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? "white" : undefined }} />
    ),
    onFilter: (value, record) =>
      (record[dataIndex] || "")
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ""
      ),
  });

  renderStatus = (status, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {status}
      </p>
    );
  };

  changeTypeTab = key => {
    this.setState({ currentTab: key });
  };
  handleTabChange = (key) => {
    this.setState({ activeKey: key });
  };
  handleSearchName = () => {
    if (!this.state.siteSelected) {
      return;
    }
    this.setState({ loading: true });
    this.props
      .findAllSpecial(this.state.siteSelected, this.state.selectedYear, this.state.selectedMonths)
      .then(() => {
        this.setState({ loading: false });
      })
      .catch((e) => {
        this.setState({ loading: false });
        Notify('error', e.message || e);
      });
  };



  render() {
    const { activeKey, size, selectedYear, selectedDepartment, selectedResponsible, selectedStatus, selectedMonths } = this.state;
    let descriptions = this.props.special.map(special => {
      return { value: special.description };
    });
    const { special } = this.props;
    let currentSpecial;

    // Deadline is optional, so fall back to the action date — filtering on the
    // deadline alone hides every record saved without one.
    const effectiveDate = (item) => {
      const raw = item.actionDeadline || item.actionDate;
      if (!raw) return null;
      const parsed = dayjs(raw);
      return parsed.isValid() ? parsed : null;
    };

    const filteredSpecial = this.props.special.filter((item) => {
      const itemDate = effectiveDate(item);
      if (!itemDate) return false;

      const matchesYear = selectedYear
        ? itemDate.format("YYYY") === String(selectedYear)
        : true;

      const matchesMonth = selectedMonths && selectedMonths.length > 0
        ? selectedMonths.includes(itemDate.format("MM"))
        : true;

      const matchesDepartment = selectedDepartment
        ? item.actionDepartment === selectedDepartment
        : true;

      const matchesResponsible = selectedResponsible
        ? item.actionResponsible === selectedResponsible
        : true;

      const matchesStatus = selectedStatus
        ? item.actionStatus === selectedStatus
        : true;

      const matchesSite = this.state.siteSelected
        ? String(item.access || "") === String(this.state.siteSelected)
        : true;

      return matchesYear && matchesMonth && matchesDepartment && matchesResponsible && matchesStatus && matchesSite;
    });

    const groupedSpecial = filteredSpecial.reduce((acc, item) => {
      // Key on YYYY-MM: it sorts lexicographically and parses without the
      // customParseFormat plugin, which this app never loads.
      const dateKey = effectiveDate(item).format("YYYY-MM");

      if (!acc[dateKey]) {
        acc[dateKey] = {
          date: dateKey,
          records: [],
          statusCounts: {
            Completed: 0,
            "In Progress": 0,
            Pending: 0,
            "On Hold": 0,
          },
        };
      }

      acc[dateKey].records.push(item);

      // Increment the status count
      const status = item.actionStatus || "Pending"; // Default to "Pending" if status is undefined
      if (acc[dateKey].statusCounts[status] !== undefined) {
        acc[dateKey].statusCounts[status]++;
      }

      return acc;
    }, {});

    // Convert grouped data to an array and calculate percentages
    const groupedSpecialArray = Object.keys(groupedSpecial)
      .map((date) => {
        const group = groupedSpecial[date];
        const totalActions = group.records.length;

        // Calculate percentages
        const statusPercentages = Object.fromEntries(
          Object.entries(group.statusCounts).map(([status, count]) => [
            status,
            totalActions > 0 ? ((count / totalActions) * 100).toFixed(0) : "0.0",
          ])
        );

        return {
          ...group,
          statusPercentages,
          date, // Include the original date for sorting
        };
      })
      .sort((a, b) => a.date.localeCompare(b.date)); // YYYY-MM sorts as a string

    // Filtered data
    const filteredData = filteredSpecial;

    // Count only items with specific statuses for percentage calculations
    const relevantItems = filteredData.filter((item) =>
      ["Completed", "In Progress", "Pending", "On Hold"].includes(item.actionStatus)
    );

    // Total number of relevant items
    const totalRelevantCount = relevantItems.length;

    // Initialize counts for each status
    const statusCounts = {
      Completed: 0,
      "In Progress": 0,
      Pending: 0,
      "On Hold": 0,
    };

    // Count occurrences of each status in the relevant items
    relevantItems.forEach((item) => {
      const status = item.actionStatus;

      if (statusCounts[status] !== undefined) {
        statusCounts[status] += 1;
      }
    });

    // Calculate percentages for each status based on relevant items
    const statusPercentages = {
      Completed: totalRelevantCount
        ? ((statusCounts.Completed / totalRelevantCount) * 100).toFixed(0)
        : 0,
      "In Progress": totalRelevantCount
        ? ((statusCounts["In Progress"] / totalRelevantCount) * 100).toFixed(0)
        : 0,
      Pending: totalRelevantCount
        ? ((statusCounts.Pending / totalRelevantCount) * 100).toFixed(0)
        : 0,
      "On Hold": totalRelevantCount
        ? ((statusCounts["On Hold"] / totalRelevantCount) * 100).toFixed(0)
        : 0,
    };


    const exportExpandedActionsToExcel = () => {

      if (!groupedSpecialArray?.length) {
        message.warning("No data to export");
        return;
      }

      // 1) Build workbook & sheet name
      const wb = XLSX.utils.book_new();
      const sheetName = "All Actions";

      // 2) Define header
      const header = [
        "Month",
        "Days to Complete",
        "Date",
        "Deadline",
        "Action Required",
        "Department",
        "Responsible",
        "Priority",
        "Status",
      ];
      const aoa = [header];

      // 3) Flatten data into rows
      groupedSpecialArray.forEach(group => {
        const monthLabel = dayjs(group.date + "-01").format("MMM YYYY");
        const recs = [...group.records].sort((a, b) =>
          dayjs(a.actionDeadline).isAfter(dayjs(b.actionDeadline)) ? 1 : -1
        );

        recs.forEach(item => {
          // compute Days to Complete text
          let daysToComplete;
          if (item.actionStatus === "Completed") {
            daysToComplete = "Completed";
          } else if (item.actionDeadline) {
            const diff = dayjs(item.actionDeadline).diff(dayjs(), "days");
            daysToComplete =
              diff >= 0 ? `${diff} days left` : `Overdue ${Math.abs(diff)} days`;
          } else {
            daysToComplete = "N/A";
          }

          aoa.push([
            monthLabel,
            daysToComplete,
            item.actionDate
              ? dayjs(item.actionDate).format("DD-MM-YYYY")
              : "No Date",
            item.actionDeadline
              ? dayjs(item.actionDeadline).format("DD-MM-YYYY")
              : "No Deadline",
            item.actionAction,
            item.actionDepartment,
            item.actionResponsible,
            item.actionPriority,
            item.actionStatus,
          ]);
        });
      });

      // 4) Convert to sheet and append
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);

      // 5) Apply styling
      const range = XLSX.utils.decode_range(ws["!ref"]);

      // (a) Header row: black bg, white bold text, centered
      for (let c = range.s.c; c <= range.e.c; c++) {
        const addr = XLSX.utils.encode_cell({ r: 0, c });
        const cell = ws[addr];
        if (cell) {
          cell.s = {
            fill: { fgColor: { rgb: "000000" } },
            font: { color: { rgb: "FFFFFF" }, bold: true },
            alignment: { horizontal: "center", vertical: "center" },
          };
        }
      }

      // (b) Column widths for readability
      ws["!cols"] = [
        { wch: 12 }, // Month
        { wch: 18 }, // Days to Complete
        { wch: 12 }, // Date
        { wch: 12 }, // Deadline
        { wch: 40 }, // Action Required
        { wch: 15 }, // Department
        { wch: 15 }, // Responsible
        { wch: 10 }, // Priority
        { wch: 12 }, // Status
      ];

      // (c) Font‐color mapping
      const statusColors = {
        Completed: "008000", // green
        "In Progress": "0000FF", // blue
        Pending: "FFA500", // orange
        "On Hold": "FF0000", // red
      };

      // Loop rows 1..end
      for (let r = 1; r <= range.e.r; r++) {
        // Days to Complete is column index 1
        {
          const addr = XLSX.utils.encode_cell({ r, c: 1 });
          const cell = ws[addr];
          if (cell && cell.v) {
            let color = null;
            if (cell.v === "Completed") {
              color = "008000";
            } else if (cell.v.includes("days left") || cell.v.includes("Overdue")) {
              // extract number if you need to check <4, but user said all red
              color = "FF0000";
            }
            if (color) {
              cell.s = {
                ...(cell.s || {}),
                font: { color: { rgb: color }, bold: true },
              };
            }
          }
        }

        // Status is the last column
        {
          const c = range.e.c;
          const addr = XLSX.utils.encode_cell({ r, c });
          const cell = ws[addr];
          if (cell && cell.v) {
            const col = statusColors[cell.v] || null;
            if (col) {
              cell.s = {
                ...(cell.s || {}),
                font: { color: { rgb: col }, bold: true },
              };
            }
          }
        }
      }

      // 6) Save file
      XLSX.writeFile(wb, "Expanded_Actions_Colored.xlsx", {
        bookType: "xlsx",
        cellStyles: true,
      });
    };
    return (
      <div style={{ maxWidth: "90em", margin: "auto" }}>
        <Spin spinning={this.state.loading}>
          {this.state.addSpecialVisible ? (
            <Cards
              bordered={false}
              extra={
                <Title
                  style={{
                    paddingRight: this.props.isMobile ? 0 : '75em',
                    fontSize: this.props.isMobile ? '17px' : '20px',
                    fontWeight: 800,
                    whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                    fontFamily: "Nunito",
                  }}
                >
                  {this.state.editSpecial ? 'Edit Action Plan' : 'Add Action Plan'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: this.props.isMobile ? '13px' : '16px',
                      whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                      marginTop: '0em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editSpecial
                      ? 'Update the action details and save your changes.'
                      : "Complete the action details and select Save when you're done."}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: '0em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  // padding: '3em',
                  // paddingTop: '1em',
                  // paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <SpecialForm
                  sites={this.props.sites}
                  siteSelected={this.state.siteSelected}
                  stock={this.props.stock}
                  users={this.props.users}
                  descriptions={descriptions}
                  editSpecial={this.state.editSpecial}
                  wrappedComponentRef={form => (this.specialForm = form)}
                />{" "}
                {this.props.isMobile ? (
                  <MobileEditActions>
                    <Button
                      size="large"
                      icon={<StopFilled />}
                      onClick={() =>
                        this.setState({
                          addSpecialVisible: false,
                          editSpecial: undefined
                        })
                      }
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      size="large"
                      icon={<CheckOutlined />}
                      onClick={this.handleAddSpecial}
                    >
                      {this.state.editSpecial ? 'Save Changes' : 'Save Action'}
                    </Button>
                  </MobileEditActions>
                ) : (
                  <FloatButton.Group
                    trigger="hover"
                    type="primary"
                    style={{ right: 24 }}
                    icon={<RocketFilled />}
                  >
                    <Tooltip placement="left" title="Save Item">
                      <FloatButton onClick={this.handleAddSpecial} icon={<PlusCircleFilled style={{ color: "#80CE90" }} />} />
                    </Tooltip>
                    <Tooltip placement="left" title="Cancel" >
                      <FloatButton onClick={e => this.setState({ addSpecialVisible: false })} icon={<StopFilled style={{ color: "red" }} />} />
                    </Tooltip>
                  </FloatButton.Group>
                )}
              </div>
            </Cards>) :

            this.state.addSliderVisible ? (
              <Cards
                bordered={false}
                extra={
                  <Title
                    style={{
                      paddingRight: this.props.isMobile ? 0 : '75em',
                      fontSize: this.props.isMobile ? '17px' : '20px',
                      fontWeight: 800,
                      whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                      fontFamily: "Nunito",
                    }}
                  >
                    {this.state.editSpecial ? 'Edit Slider' : 'Add Slider'}
                    <p
                      style={{
                        fontWeight: 400,
                        fontSize: this.props.isMobile ? '13px' : '16px',
                        whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                        marginTop: '0em',
                        marginBottom: '0em'
                      }}
                    >
                      {this.state.editSpecial
                        ? "Complete all fields and click 'Save' to showcase your slider"
                        : "Present Your Products with an Engaging Product Slider"}
                    </p>
                  </Title>
                }
                style={{
                  margin: 'auto',
                  marginTop: '0em',
                  backgroundColor: 'white',
                  borderRadius: '0.8em',
                  boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
                }}
              >
                <div
                  style={{
                    // padding: '3em',
                    // paddingTop: '1em',
                    // paddingBottom: '4em',
                    margin: 'auto'
                  }}
                >
                  <SliderForm
                    sites={this.props.sites}
                    stock={this.props.stock}
                    descriptions={descriptions}
                    editSpecial={this.state.editSpecial}
                    wrappedComponentRef={form => (this.sliderForm = form)}
                  />{" "}
                  <FloatButton.Group
                    trigger={this.props.isMobile ? 'click' : 'hover'}
                    type="primary"
                    style={{
                      right: 24,
                    }}
                    icon={<RocketFilled />}
                  >
                    <Tooltip placement="left" title="Save Item">
                      <FloatButton onClick={this.handleAddSlider} icon={<PlusCircleFilled style={{ color: "#80CE90" }} />} />
                    </Tooltip>
                    <Tooltip placement="left" title="Cancel" >
                      <FloatButton onClick={e => this.setState({ addSliderVisible: false })} icon={<StopFilled style={{ color: "red" }} />} />
                    </Tooltip>
                  </FloatButton.Group>
                </div>
              </Cards>
            ) : (


              <>
                <Row gutter={[16, 12]}>
                  <Col xs={24} lg={6}>

                    <h1 style={{
                      marginBottom: '0em',
                      marginRight: "1em",
                      fontSize: '22px',
                      fontWeight: 800,
                      fontFamily: "Nunito",
                      marginTop: "0.3em",
                    }}>Action Plan Management</h1>
                  </Col>
                  <Col xs={24} lg={18}>
                    <ActionPlanToolbar>
                    <Button
                      className="action-export"
                      type="primary"
                      style={{ backgroundColor: "black", marginTop: "0.3em" }}
                      onClick={exportExpandedActionsToExcel}
                    >
                      <DownloadOutlined />
                    </Button>
                    <Button
                      className="action-add"
                      type="primary"
                      onClick={this.onAddSpecial}
                      icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                      size="large"
                      style={{}}
                    >
                      Add Action
                    </Button>
                    {/* Month Picker */}



                    <DatePicker
                      picker="year"
                      format="YYYY"
                      placeholder="Year"
                      size="large"
                      defaultValue={dayjs()}
                      allowClear={false}
                      style={{ width: this.props.isMobile ? '100%' : 130 }}
                      onChange={(date) => {
                        const selectedYear = date ? date.format("YYYY") : null;

                        this.setState({ selectedYear, selectedMonths: [dayjs().format("MM")] }, async () => {
                          this.setState({ loading: true });
                          await this.fetchAllSpecial(); // Re-fetch data based on new year
                          this.setState({ loading: false });
                        });
                      }}
                    />


                    {/* Department Filter */}
                    <Select
                      placeholder="Department"
                      size="large"
                      style={{ width: this.props.isMobile ? '100%' : 130 }}
                      onChange={(value) => this.setState({ selectedDepartment: value })}
                      allowClear
                    >
                      <Option key="HR" value="HR" >
                        HR
                      </Option>
                      <Option key="Collateral" value="Collateral" >
                        Collateral
                      </Option>
                      <Option key="Guest experience" value="Guest experience" >
                        Guest experience
                      </Option>
                      <Option key="Guest feedback" value="Guest feedback" >
                        Guest feedback
                      </Option>
                      <Option key="Laundry" value="Laundry" >
                        Laundry
                      </Option>
                      <Option key="Service stock" value="Service stock" >
                        Service stock
                      </Option>
                      <Option key="Maintenance" value="Maintenance" >
                        Maintenance
                      </Option>
                      <Option key="Operations" value="Operations" >
                        Operations
                      </Option>
                      <Option key="Health & Safety" value="Health & Safety" >
                        Health & Safety
                      </Option>
                      <Option key="Finance" value="Finance" >
                        Finance
                      </Option>
                      <Option key="BOH" value="BOH" >
                        BOH
                      </Option>
                      <Option key="Service Training" value="Service Training" >
                        Service Training
                      </Option>
                      {/* {Array.from(new Set(this.props.special.map((item) => item.actionDepartment))).map((dept) => (
                      <Select.Option key={dept} value={dept}>
                        {dept}
                      </Select.Option>
                    ))} */}
                    </Select>

                    {/* Responsible Filter */}
                    <Select
                      placeholder="Responsible"
                      size="large"
                      style={{ width: this.props.isMobile ? '100%' : 130 }}
                      onChange={(value) => this.setState({ selectedResponsible: value })}
                      allowClear
                    >
                      {Array.from(new Set(this.props.special.map((item) => item.actionResponsible))).map((resp) => (
                        <Select.Option key={resp} value={resp}>
                          {resp}
                        </Select.Option>
                      ))}
                      {/* {this.props.users.map(user => (
                      <Option key={user._id} value={user.name}>
                        {user.name}
                      </Option>
                    ))} */}
                    </Select>

                    {/* Status Filter */}
                    <Select
                      placeholder="Status"
                      size="large"
                      style={{ width: this.props.isMobile ? '100%' : 130 }}
                      onChange={(value) => this.setState({ selectedStatus: value })}
                      allowClear
                    >
                      {Array.from(new Set(this.props.special.map((item) => item.actionStatus))).map((status) => (
                        <Select.Option key={status} value={status}>
                          {status}
                        </Select.Option>
                      ))}
                    </Select>
                    <Select
                      className="action-site"
                      size="large"
                      value={this.state.siteSelected} // Bind selected values to state
                      showSearch
                      onChange={values => {
                        this.props.setSelectedSite(values);
                        this.setState({ siteSelected: values }, () => {
                          this.handleSearchName();
                        });
                      }}
                      style={{ width: this.props.isMobile ? '100%' : 130 }}
                      placeholder="Select Company"
                      optionFilterProp="children"
                    >
                      {/* <Select.Option key="Admin" value="Admin">
                        Admin
                      </Select.Option> */}
                      {/* Options for sites */}
                      {this.props.sites.map(site => (
                        <Option key={site._id} value={site._id}>
                          {site.name}
                        </Option>
                      ))}
                    </Select>
                    </ActionPlanToolbar>
                  </Col>
                </Row>
                <Row style={{ marginTop: "1em" }}>
                  <Col span={24}>
                    <ActionPlanStatusBar>
                    <Tag color="green" style={{ fontSize: 16, padding: 8 }}>
                      Completed: {statusPercentages.Completed}%
                    </Tag>
                    <Tag color="blue" style={{ fontSize: 16, padding: 8 }}>
                      In Progress: {statusPercentages["In Progress"]}%
                    </Tag>
                    <Tag color="orange" style={{ fontSize: 16, padding: 8 }}>
                      Pending: {statusPercentages.Pending}%
                    </Tag>
                    <Tag color="red" style={{ fontSize: 16, padding: 8 }}>
                      On Hold: {statusPercentages["On Hold"]}%
                    </Tag>
                    <Select
                      style={{
                        width: this.props.isMobile ? '100%' : '39.5em',
                        float: this.props.isMobile ? 'none' : 'right',
                        marginTop: this.props.isMobile ? '1em' : 0
                      }}
                      size="large"
                      mode="multiple"
                      placeholder="Select Months"
                      value={this.state.selectedMonths}
                      onChange={(selectedMonths) => {
                        if (selectedMonths.length === 0) {
                          message.warning("At least one month must remain selected.");
                          return;
                        }

                        this.setState({ selectedMonths }, async () => {
                          this.setState({ loading: true });
                          await this.fetchAllSpecial();
                          this.setState({ loading: false });
                        });
                      }}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const monthValue = `${String(i + 1).padStart(2, "0")}`;
                        return (
                          <Select.Option key={monthValue} value={monthValue}>
                            {dayjs().month(i).format("MMMM")}
                          </Select.Option>
                        );
                      })}
                    </Select>
                    </ActionPlanStatusBar>
                  </Col>
                </Row>
                <Row >
                  <Col span={24}>
                    <MobileTableHelp>
                      <strong>SWIPE</strong>
                      Swipe sideways for more columns. Tap + to open actions.
                    </MobileTableHelp>
                    <StyledTable
                      bordered={false}
                      dataSource={groupedSpecialArray}
                      rowKey="date"
                      size="middle"
                      pagination={false}
                      scroll={
                        this.props.isMobile ? { x: 'max-content' } : undefined
                      }
                      style={{
                        minWidth: "15em",
                        marginTop: "1em",
                      }}
                      expandable={{
                        expandedRowRender: (record) => (
                          <StyledTable
                            bordered={false}
                            scroll={
                              this.props.isMobile
                                ? { x: 'max-content' }
                                : undefined
                            }
                            dataSource={record.records.sort((a, b) =>
                              dayjs(a.actionDeadline).isAfter(dayjs(b.actionDeadline)) ? -1 : 1
                            )} // Sort by `actionDeadline` in ascending order
                            rowKey={(item) => item._id}
                            pagination={false}
                            columns={[
                              {
                                title: "Days to Complete",
                                key: "daysToComplete",
                                render: (text, record) => {
                                  const today = dayjs();
                                  const actionDeadline = record.actionDeadline ? dayjs(record.actionDeadline) : null;
                                  const status = record.actionStatus; // Retrieve status from the record

                                  // Check if status is Completed
                                  if (status === "Completed") {
                                    return <span style={{ color: "green", fontWeight: 500 }}>Completed</span>;
                                  }

                                  if (actionDeadline) {
                                    const daysLeft = actionDeadline.diff(today, "days");

                                    return (
                                      <span style={{ color: daysLeft < 4 ? "red" : "inherit", fontWeight: daysLeft < 4 ? 500 : 500 }}>
                                        {daysLeft >= 0 ? `${daysLeft} days left` : `Overdue ${Math.abs(daysLeft)} days`}
                                      </span>
                                    );
                                  } else {
                                    return "N/A"; // Handle missing deadlines
                                  }
                                },
                              },

                              {
                                title: "Date",
                                dataIndex: "actionDate",
                                key: "actionDate",
                                render: (text) =>
                                  text ? dayjs(text).format("DD-MM-YYYY") : "No Deadline",
                              },
                              {
                                title: "Deadline",
                                dataIndex: "actionDeadline",
                                key: "actionDeadline",
                                render: (text) =>
                                  text ? dayjs(text).format("DD-MM-YYYY") : "No Deadline",
                              },
                              {
                                ...this.getColumnSearchProps('actionAction'),
                                title: "Action Required",
                                dataIndex: "actionAction",
                                key: "actionAction",
                                render: (text) => (
                                  <Tooltip title={text}>
                                    <span>
                                      {text && text.length > 45 ? `${text.substring(0, 45)}...` : text}
                                    </span>
                                  </Tooltip>
                                ),
                              },
                              { title: "Department", dataIndex: "actionDepartment", key: "actionDepartment" },
                              { title: "Responsible", dataIndex: "actionResponsible", key: "actionResponsible" },
                              {
                                title: "Priority",
                                dataIndex: "actionPriority",
                                key: "actionPriority",
                                sorter: (a, b) => a.actionPriority - b.actionPriority, // Sorting logic
                                render: (priority) => {
                                  const priorityColors = {
                                    5: "green",
                                    4: "blue",
                                    3: "orange",
                                    2: "red",
                                    1: "crimson",
                                  };
                                  return (
                                    <Tag color={priorityColors[priority] || "default"} key={priority}>
                                      {priority}
                                    </Tag>
                                  );
                                },
                              },

                              {
                                title: "Status", dataIndex: "actionStatus", key: "actionStatus", render: (status) => {
                                  // Define color mapping for each status
                                  const statusColors = {
                                    Completed: "green",
                                    "In Progress": "blue",
                                    Pending: "orange",
                                    "On Hold": "red",
                                  };

                                  return (
                                    <Tag color={statusColors[status] || "default"} key={status}>
                                      {status}
                                    </Tag>
                                  );
                                }
                              },
                              {
                                title: "Actions",
                                fixed: this.props.isMobile ? "right" : undefined,
                                width: 96,
                                render: (text, special) => (
                                  <span>
                                    <Tooltip
                                      placement="top"
                                      title="Edit Details"
                                    >
                                      <EditFilled
                                        style={{
                                          backgroundColor: '#80CE90',
                                          color: 'white',
                                          padding: '0.5em',
                                          borderRadius: '3em'
                                        }}

                                        onClick={() => this.handleEditSpecial(special)}
                                      />
                                    </Tooltip>

                                    <Divider type="vertical" />
                                    <Tooltip placement="top" title="Delete">
                                      <DeleteFilled
                                        style={{
                                          backgroundColor: 'crimson',
                                          color: 'white',
                                          padding: '0.5em',
                                          borderRadius: '3em'
                                        }}
                                        data={special._id}
                                        onClick={this.handleDeleteSpecial}
                                      />
                                    </Tooltip>
                                  </span>
                                ),
                              },
                            ]}
                          />
                        ),
                      }}
                    >
                      <Column
                        title="Date"
                        dataIndex="date"
                        key="date"
                        render={(text) => <span>{dayjs(text + "-01").format("MMM YYYY")}</span>}
                      />
                      <Column
                        title="% Completed"
                        key="percentCompleted"
                        render={(text, record) =>
                          <Tag color={"green"} >
                            {record.statusPercentages.Completed}%</Tag>
                        }
                      />
                      <Column
                        title="% In Progress"
                        key="percentInProgress"
                        render={(text, record) =>
                          <Tag color={"blue"} >
                            {record.statusPercentages["In Progress"]}%</Tag>
                        }
                      />
                      <Column
                        title="% Pending"
                        key="percentPending"
                        render={(text, record) =>
                          <Tag color={"orange"} >
                            {record.statusPercentages.Pending}%</Tag>
                        }
                      />
                      <Column
                        title="% On Hold"
                        key="percentOnHold"
                        render={(text, record) =>
                          <Tag color={"red"} >
                            {record.statusPercentages["On Hold"]}%</Tag>
                        }
                      />
                      <Column
                        title="Number of Actions"
                        key="numberOfActions"
                        render={(text, record) => record.records.length}
                      />
                    </StyledTable>
                  </Col>
                </Row></>
            )}
        </Spin>
      </div >
    );
  }
}

const WrappedSpecial = Form.create()(withIsMobile(Special));
export default WrappedSpecial;
